import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** `404` (`NoOpenCycle`) when the member has no open entitlement cycle. */
export function useMyTimeOffBalance() {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.myBalance(orgId),
    queryFn: ({ signal }) => timeOffService.getMyBalance(signal),
    staleTime: 60_000,
    enabled: !!orgId,
  });
}
